import { curry } from "lodash";

export const _optionalApply = (fn: (val: any) => any, val?: any) => val && fn(val);

export const _valOrAlt = (altVal: any, val?: any) => val || altVal;

export const optionalApply = curry(_optionalApply);
export const valOrAlt = curry(_valOrAlt);
